"use strict";
var __assign =
    (this && this.__assign) ||
    function () {
        __assign = Object.assign;
        return __assign.apply(this, arguments);
    };

theme.initProductVariant = function () {
    // productSingleObject is a global JSON object defined in product.liquid
    if (!theme.productSingleObject) {
        return;
    }
    // Initialize multiple variant selector dropdowns
    new Shopify.OptionSelectors("ProductSelect", {
        product: theme.productSingleObject,
        onVariantSelected: theme.productVariantCallback,
        enableHistoryState: true,
    });
    // option_selection.js does not add a label if there is only one variant option.
    // Add one as long as it is not 'Title' (the Shopify default), add one.
    var selectorWrapper = dq(".selector-wrapper");
    if (theme.productSingleObject.options.length === 1 && theme.productSingleObject.options[0] !== "Title") {
        var label = document.createElement("label");
        label.setAttribute("for", "ProductSelect-option-0");
        label.innerText = theme.productSingleObject.options[0];
        selectorWrapper === null || selectorWrapper === void 0 ? void 0 : selectorWrapper.insertBefore(label, selectorWrapper.firstChild);
    }
    // Hide variant dropdown if only one exists and title contains 'Default'
    if (theme.productSingleObject.variants.length && theme.productSingleObject.variants[0].title.indexOf("Default") >= 0) {
        selectorWrapper === null || selectorWrapper === void 0 ? void 0 : selectorWrapper.classList.add("hide");
    }
    theme.productVariantLayout();
};
theme.productVariantLayout = function () {
    dqa(".selector-wrapper").forEach((selector) => selector.classList.add("product-form__item"));
    dqa(".single-option-selector").forEach((option) => option.classList.add("product-form__input"));
};
theme.switchImage = function (image, largeImage) {
    if (!theme.cache.$productFeaturedImage) return;
    theme.cache.$productFeaturedImage.setAttribute("src", image);
    theme.cache.$productImageModalTrigger.setAttribute("href", largeImage);
};
function createArrowButton(arrowIconTemplate, direction) {
    var arrowIcon = arrowIconTemplate.content.cloneNode(true);
    var arrowButton = document.createElement("button");
    arrowButton.type = "button";
    arrowButton.classList.add("slick-".concat(direction), "slick-arrow");
    if (direction == "prev") {
        arrowButton.classList.add("hidden");
        arrowButton.ariaLabel = "View more images to the left";
    } else {
        arrowButton.ariaLabel = "View more images to the right";
    }
    var arrowSpan = document.createElement("span");
    arrowSpan.append(arrowIcon);
    arrowButton.appendChild(arrowSpan);
    return arrowButton;
}
function scrollThumbs(direction) {
    if (direction === void 0) {
        direction = 1;
    }
    var thumbSlider = theme.cache.$productThumbs;
    var clientWidth = thumbSlider.clientWidth;
    thumbSlider.scrollBy({ left: clientWidth * direction, top: 0, behavior: "smooth" });
}
theme.productThumbnailSlider = function () {
    var arrowIconTemplate = document.getElementById("arrowIcon");
    if (!arrowIconTemplate) {
        return;
    }
    var thumbnailCount = parseInt(arrowIconTemplate.dataset.count);
    // Only init slider if 3+ products
    if (thumbnailCount > 3) {
        // sliderArrows is an object defined in product.liquid to set custom
        // SVG arrow icons.
        var nextArrow = createArrowButton(arrowIconTemplate, "next");
        var prevArrow = createArrowButton(arrowIconTemplate, "prev");
        // var nextArrow = '<button type="button" class="slick-next"><span>' + arrowIcon+ "</span></button>";
        // var prevArrow = '<button type="button" class="slick-prev"><span>' + arrowIcon + "</span></button>";
        // Show highlighted thumbnail, reposition slider without animation.
        var thumbnails = dq(".photos__item--thumbs");
        thumbnails.prepend(prevArrow);
        thumbnails.append(nextArrow);
        prevArrow.addEventListener("click", function () {
            return scrollThumbs(-1);
        });
        nextArrow.addEventListener("click", function () {
            return scrollThumbs(1);
        });
        theme.cache.$productThumbs.addEventListener(
            "scroll",
            function (event) {
                return scrollHandler(event, nextArrow, prevArrow);
            },
            { passive: true },
        );
    }
};
function scrollHandler(_a, nextArrow, prevArrow) {
    var currentTarget = _a.currentTarget;
    var _b = currentTarget,
        scrollLeft = _b.scrollLeft,
        scrollWidth = _b.scrollWidth,
        clientWidth = _b.clientWidth;
    var compareScroll = scrollLeft - (scrollWidth - clientWidth);
    if (Math.pow(compareScroll, 2) <= 2) {
        nextArrow.classList.add("hidden");
        prevArrow.classList.remove("hidden");
    } else if (!scrollLeft) {
        nextArrow.classList.remove("hidden");
        prevArrow.classList.add("hidden");
    } else {
        nextArrow.classList.remove("hidden");
        prevArrow.classList.remove("hidden");
    }
}
//var A11y = ShopifyCanvas.A11yHelpers;
class QtySelector {
    constructor($el) {
        this.cache = {
            body: document.body,
            subtotal: document.getElementById("CartSubtotal"),
            discountTotal: document.getElementById("cartDiscountTotal"),
            cartTable: document.querySelector(".cart-table"),
            cartTemplate: document.getElementById("CartProducts"),
            cartFooter: document.getElementById("CartFooter"),
            cartFooterTemplate: document.getElementById("CartFooterTemplate"),
        };
        this.settings = {
            loadingClass: "js-qty--is-loading",
            isCartTemplate: this.cache.body.classList.contains("template-cart"),
            minQty: this.cache.body.classList.contains("template-cart") ? 0 : 1,
        };
        this.$el = $el;
        this.qtyUpdateTimeout;
        this.createInputs();
        this.bindEvents();
    }
    createInputs() {
        var $el = this.$el;
        var content = document.getElementById("QuantityTemplate").content;
        var input = content.querySelector("input");
        input.setAttribute("value", $el.value);
        input.id = $el.id;
        input.name = $el.name;
        input.dataset.line = $el.dataset.line;
        $el.before(content);
        this.$wrapper = document.querySelector(".js-qty");
        // Remove original number input
        $el.remove();
    }
    validateAvailability(line, quantity) {
        var product = window.cartObject.items[line - 1]; // 0-based index in API
        var handle = product.handle; // needed for the ajax request
        var id = product.id; // needed to find right variant from ajax results
        this.validateAvailabilityCallback(line, quantity, id, product);
    }
    validateAvailabilityCallback(line, quantity, id, product) {
        var quantityIsAvailable = true;
        // This returns all variants of a product.
        // Loop through them to get our desired one.
        for (var i = 0; i < product.variants.length; i++) {
            var variant = product.variants[i];
            if (variant.id === id) {
                break;
            }
        }
        if (quantityIsAvailable) {
            // this func doesnt exist?
            //this.updateItemQuantity(line, quantity);
        }
    }
    validateQty(qty) {
        var parsedQty = parseInt(qty);
        // I have no idea why the old file had parseFloat wtf
        if (!isNaN(parsedQty)) {
            return parsedQty;
        } else {
            // Not a number. Default to 1.
            return 1;
        }
    }
    adjustQty(evt) {
        var el = evt.currentTarget;
        var inputParent = el.parentElement;
        var input = inputParent.querySelector(".js-qty__input");
        var qty = this.validateQty(input.value);
        var line = input.getAttribute("line");
        if (el.classList.contains("js-qty__adjust--minus")) {
            qty--;
            if (qty <= this.settings.minQty) {
                qty = this.settings.minQty;
            }
        } else {
            qty++;
        }
        if (this.settings.isCartTemplate) {
            inputParent.classList.add(this.settings.loadingClass);
            dq(".meucartsubtotalvalor").classList.add(this.settings.loadingClass);
            this.updateCartItemPrice(line, qty);
        } else {
            input.value = qty.toString();
        }
    }
    bindEvents() {
        var _this = this;
        var buttonAdjust = this.$wrapper.querySelectorAll(".js-qty__adjust");
        buttonAdjust.forEach(function (button) {
            return button.addEventListener("click", function (e) {
                return _this.adjustQty(e);
            });
        });
        // Select input text on click
        buttonAdjust.forEach(function (button) {
            return button.addEventListener("click", function (evt) {
                var target = evt.target;
                if (target.classList.contains("js-qty__input")) {
                    //@ts-ignore
                    _this.setSelectionRange(0, target.value.length);
                }
            });
        });
        // If the quantity changes on the cart template, update the price
        if (this.settings.isCartTemplate) {
            buttonAdjust.forEach(function (button) {
                return button.addEventListener("change", function (evt) {
                    var target = evt.currentTarget;
                    if (target.classList.contains("js-qty__input")) {
                        var line = target.dataset.line;
                        var qty = _this.validateQty(target.value);
                        target.parentElement.classList.add(_this.settings.loadingClass);
                        _this.updateCartItemPrice(line, qty);
                    }
                });
            });
        }
    }
    updateCartItemPrice(line, qty) {
        var _this = this;
        // Update cart after short timeout so user doesn't create simultaneous ajax calls
        clearTimeout(this.qtyUpdateTimeout);
        if (!line) return;
        this.qtyUpdateTimeout = setTimeout(function () {
            return _this.validateAvailability(parseInt(line), qty);
        }, 200);
    }
}
theme.productImageSwitch = function () {
    if (!theme.cache.$productThumbs) {
        return;
    }
    theme.cache.$productThumbs.addEventListener("click", function (evt) {
        var target = evt.target;
        var el = target.closest(".product-single__thumbnail");
        if (el) {
            evt.preventDefault();
            var sizedImageUrl = el.getAttribute("href");
            var largeImageUrl = el.getAttribute("data-zoom");
            theme.setActiveThumbnail(el);
            theme.switchImage(sizedImageUrl, largeImageUrl);
        }
    });
};
class Modals {
    constructor(id, name, options) {
        var _a;
        this.modalIsOpen = false;
        var defaults = {
            close: ".js-modal-close",
            open: ".js-modal-open-".concat(name),
            openClass: "modal--is-active",
        };
        this.modal = getById(id);
        if (!this.modal) {
            return;
        }
        this.config = __assign(__assign({}, defaults), options);
        this.focusOnOpen = (_a = this.config.focusOnOpen) !== null && _a !== void 0 ? _a : this.modal;
        this.init();
    }
    init() {
        var _this = this;
        var openBtn = dq(this.config.open);
        // Add aria controls
        openBtn.setAttribute("aria-expanded", "false");
        openBtn.addEventListener("click", this.open.bind(this));
        this.modal.querySelectorAll(this.config.close).forEach(function (closeBtn) {
            closeBtn.addEventListener("click", _this.close.bind(_this));
        });
    }
    open(evt) {
        // Keep track if modal was opened from a click, or called by another function
        var externalCall = false;
        // don't open an opened modal
        if (this.modalIsOpen) {
            return;
        }
        // Prevent following href if link is clicked
        if (evt) {
            evt.preventDefault();
        } else {
            externalCall = true;
        }
        // Without this, the modal opens, the click event bubbles up to this.body
        // which closes the modal.
        if (evt && evt.stopPropagation) {
            evt.stopPropagation();
            // save the source of the click, we'll focus to this on close
            this.activeSource = evt.currentTarget;
        }
        if (this.modalIsOpen && !externalCall) {
            return this.close();
        }
        this.modal.classList.add(this.config.openClass);
        document.body.classList.add(this.config.openClass);
        this.modalIsOpen = true;
        // Set focus on modal
        //this.a11y.trapFocus(this.focusOnOpen, "modal_focus");
        if (this.activeSource && this.activeSource.getAttribute("aria-expanded")) {
            this.activeSource.setAttribute("aria-expanded", "true");
        }
        this.bindEvents();
    }
    close() {
        // don't close a closed modal
        if (!this.modalIsOpen) {
            return;
        }
        // deselect any focused form elements
        document.activeElement.blur();
        this.modal.classList.remove(this.config.openClass);
        document.body.classList.remove(this.config.openClass);
        this.modalIsOpen = false;
        // Remove focus on modal
        //this.a11y.removeTrapFocus(this.focusOnOpen, "modal_focus");
        if (this.activeSource && this.activeSource.getAttribute("aria-expanded")) {
            this.activeSource.setAttribute("aria-expanded", "false");
            this.activeSource.focus();
        }
        this.unbindEvents();
    }
    handleParentKeyUp(evt) {
        if (evt.code == "Escape" || evt.keyCode === 27) {
            this.close();
        }
    }
    bindEvents() {
        var _this = this;
        // Pressing escape closes modal
        document.body.addEventListener("keyup", function (evt) {
            return _this.handleParentKeyUp(evt);
        });
    }
    unbindEvents() {
        document.body.removeEventListener("keyup", this.handleParentKeyUp);
    }
}
theme.setActiveThumbnail = function (el) {
    // If there is no element passed, find it by the current product image
    // Set active thumbnail class
    var thumbs = theme.cache.$productThumbs;
    if (!thumbs) {
        return;
    }
    thumbs.querySelector(".product-single__thumbnail-item").classList.remove("is-active");
    el.parentElement.classList.add("is-active");
    // If there is a slick carousel, get the slide index, and position it into view with animation.
};
theme.productVariantCallback = function (variant, selector) {
    var atcButton = theme.cache.$addToCart;
    if (!variant) {
        atcButton.toggleAttribute("disabled");
        atcButton.textContent = theme.strings.unavailable;
        if (theme.settings.productStockSetting) {
            dq(".product-stock").classList.add("hide");
        }
        return;
    }
    // Update variant image, if one is set
    if (variant.featured_image && theme.cache.$productFeaturedImage) {
        var size = Shopify.Image.imageSize(theme.cache.$productFeaturedImage.src);
        var sizedImgUrl = Shopify.Image.getSizedImageUrl(variant.featured_image.src, size);
        var largeImgUrl = Shopify.Image.getSizedImageUrl(variant.featured_image.src, "1024x1024");
        theme.switchImage(sizedImgUrl, largeImgUrl);
        theme.setActiveThumbnail(theme.cache.$productFeaturedImage);
    }
    // Select a valid variant if available
    if (variant.available) {
        // We have a valid product variant, so enable the submit button
        atcButton.classList.remove("btn--sold-out");
        atcButton.toggleAttribute("disabled", false); // old code used to set this to false, check if it works
        atcButton.addEventListener("click", function (event) {
            var target = event.target;
            target.parentElement.classList.add("js-qty--is-loading");
        });
        theme.cache.$addToCartText.textContent = theme.strings.addToCart;
    } else {
        // Variant is sold out, disable the submit button
        atcButton.toggleAttribute("disabled", true);
        atcButton.classList.add("btn--sold-out");
        theme.cache.$addToCartText.textContent = theme.strings.soldOut;
        if (theme.settings.productStockSetting && theme.cache.$productStock) {
            theme.cache.$productStock.classList.add("hide");
        }
    }
};
theme.productZoomImage = function () {
    if (!theme.cache.$productFeaturedImage) {
        return;
    }
    theme.ProductModal = new Modals("ProductModal", "product-modal");
    theme.cache.$productImageModalTrigger.addEventListener("click", function (evt) {
        // Empty src before loading new image to avoid awkward image swap
        var currentTarget = evt.currentTarget;
        evt === null || evt === void 0 ? void 0 : evt.preventDefault();
        var productZoom = theme.cache.$productZoomImage;
        productZoom.classList.add("lazyload");
        productZoom.setAttribute("src", "");
        productZoom.setAttribute("src", currentTarget.getAttribute("href") || "");
        theme.ProductModal.open();
    });
    // Close modal if clicked, but not if the image is clicked
    theme.ProductModal.modal.addEventListener("click", function (evt) {
        var target = evt.target || null;
        if ((target === null || target === void 0 ? void 0 : target.tagName) !== "IMG") {
            theme.ProductModal.close();
        }
    });
};
theme.initHeaderSearch = function () {
    var searchForms = dqa(".site-header__search");
    var _loop_1 = function (index) {
        var searchForm = searchForms[index];
        var input = searchForm.querySelector("." + theme.headerSearch.inputClass);
        var submit = searchForm.querySelector("." + theme.headerSearch.submitClass);
        input.addEventListener("focus", function () {
            input.classList.add(theme.headerSearch.searchShowClass);
        });
        input.addEventListener("blur", function () {
            if (input.value) {
                input.classList.add(theme.headerSearch.searchShowClass);
            } else {
                input.classList.remove(theme.headerSearch.searchShowClass);
            }
        });
        submit.addEventListener("click", function (evt) {
            if (!input.classList.contains(theme.headerSearch.searchShowClass)) {
                evt.preventDefault();
                input.classList.add(theme.headerSearch.searchShowClass);
                input.focus();
            }
        });
    };
    for (var index = 0; index < searchForms.length; index++) {
        _loop_1(index);
    }
};
theme.sizeNav = function () {
    var navWidth = 0;
    var parentWidth = theme.cache.$siteNavParent.offsetWidth;
    var hideClass = "hide";
    // Set height on nav-bar wrapper so when fixed, doesn't break layout
    // theme.cache.$stickNavWrapper.style.height = theme.cache.$stickyNav.offsetHeight + 'px';
    // Calculate the width of each nav item
    // after forcing them to be visible for the calculations
    theme.cache.$siteNav.classList.remove(hideClass);
    var siteNavItems = theme.cache.$siteNavItem;
    for (var i = 0; i < siteNavItems.length; i++) {
        navWidth += siteNavItems[i].offsetWidth;
    }
    if (navWidth > parentWidth) {
        theme.cache.$siteNav.classList.add(hideClass);
        theme.cache.$siteNavCompressed.classList.remove(hideClass);
    } else {
        theme.cache.$siteNav.classList.remove(hideClass);
        theme.cache.$siteNavCompressed.classList.add(hideClass);
    }
};
theme.siteNavSizing = function () {
    theme.sizeNav();
    var resizeTimeout;
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(theme.sizeNav, 250);
};
theme.drawerSearch = function () {
    theme.cache.$drawerSearchSubmit.addEventListener("click", function (evt) {
        if (theme.cache.$drawerSearch.value.length == 0) {
            evt.preventDefault();
            theme.cache.$drawerSearch.focus();
        }
    });
};

class Meganav {
    constructor(options) {
        this.cache = {
            $document: document,
            $page: getById("PageContainer"),
        };
        const defaultConfig = {
            isOpen: false,
            preventDuplicates: false,
            closeOnPageClick: false,
            activeClass: "meganav--active",
            noAnimationClass: "meganav--no-animation",
        };
        this.config = __assign(__assign({}, defaultConfig), options);
        this.init();
    }
    init() {
        var _this = this;
        var openBtns = this.config.$meganavToggle;
        // Add aria controls
        openBtns.forEach(function (button) {
            return button.setAttribute("aria-expanded", "false");
        });
        openBtns.forEach(function (button) {
            return button.setAttribute("aria-controls", button.getAttribute("data-aria-controls") || "");
        });
        openBtns.forEach(function (button) {
            return button.addEventListener("click", function (evt) {
                return _this.requestMeganav(evt);
            });
        });
    }
    requestMeganav(evt) {
        // Prevent following href if link is clicked
        evt.preventDefault();
        // Without this, the meganav opens, the click event bubbles up to
        // theme.cache.$page which closes the drawer.
        evt.stopPropagation();
        var el = evt.currentTarget;
        var targetedMeganav = getById(el.getAttribute("aria-controls"));
        var anotherNavIsOpen = this.config.isOpen;
        // Navigate to link href or close menu if already active
        if (el.classList.contains(this.config.activeClass)) {
            if (el.tagName === "A") {
                return (window.location.href = el.getAttribute("href") || "");
            } else {
                // It is active but has no link. Close just that meganav
                return this.close(evt, el);
            }
        }
        // If true, don't let multiple meganavs be open simultaneously
        if (this.config.preventDuplicates) {
            this.close(evt);
        }
        // Set active class on toggle button/link
        el.classList.add(this.config.activeClass);
        el.setAttribute("aria-expanded", "true");
        // Show targeted nav, letting it know whether another meganav is already open
        this.open(targetedMeganav, anotherNavIsOpen);
        // Setup event handlers when meganav is open
        this.bindEvents();
        this.config.isOpen = true;
    }
    open(target, noAnimation) {
        target.classList.add(this.config.activeClass);
        // Add class to override animation - CSS determined
        if (noAnimation) {
            target.classList.add(this.config.noAnimationClass);
        }
    }
    close(evt, target) {
        var _this = this;
        if (this.config.preventDuplicates) {
            // Close all meganavs
            var meganavs = this.config.$meganavs;
            var meganavToggle = this.config.$meganavToggle;
            meganavs.forEach(function (meganav) {
                return meganav.classList.remove(_this.config.activeClass, _this.config.noAnimationClass);
            });
            meganavs.forEach(function (meganav) {
                return meganav.classList.remove(_this.config.activeClass, _this.config.noAnimationClass);
            });
            meganavToggle.forEach(function (button) {
                return button.classList.remove(_this.config.activeClass);
            });
            meganavToggle.forEach(function (button) {
                return button.setAttribute("aria-expanded", "false");
            });
        } else {
            // Close targeted nav
            if (!target) return;
            var targetedMeganav = getById(target.getAttribute("aria-controls") || "");
            targetedMeganav.classList.remove(this.config.activeClass, this.config.noAnimationClass);
            target.classList.remove(this.config.activeClass);
            target.setAttribute("aria-expanded", "false");
        }
        // Remove event listeners
        this.unbindEvents();
        this.config.isOpen = false;
    }
    handleOutsideClick(evt) {
        var target = evt.target;
        const _this = this
        var clickedInsideNav = Array.from(this.config.$meganavs).some(function (meganav) {
            return meganav.contains(target);
        });
        var clickedToggle = Array.from(this.config.$meganavToggle).some(function (button) {
            return button.contains(target);
        });
        if (!clickedInsideNav && !clickedToggle) {
            this.close();
        }
    }
    bindEvents() {
        var _this = this;
        if (!this.config.closeOnPageClick) {
            return;
        }
        this._outsideClickHandler = function (evt) {
            return _this.handleOutsideClick(evt);
        };
        this._keyboardCloseHandler = function (evt) {
            return _this.keyboardClose(evt);
        };
        this.cache.$document.addEventListener("click", this._outsideClickHandler);
        this.cache.$document.addEventListener("keyup", this._keyboardCloseHandler);
    }
    keyboardClose(evt) {
        if (evt.code !== "Escape" && evt.keyCode !== 27) {
            return;
        }
        var _this = this;
        var openBtns = this.config.$meganavToggle;
        openBtns.forEach(function (button) {
            if (button.classList.contains(_this.config.activeClass)) {
                button.focus();
            }
        });
        this.close();
    }
    unbindEvents() {
        if (!this.config.closeOnPageClick) {
            return;
        }
        if (this._outsideClickHandler) {
            this.cache.$document.removeEventListener("click", this._outsideClickHandler);
            this._outsideClickHandler = null;
        }
        if (this._keyboardCloseHandler) {
            this.cache.$document.removeEventListener("keyup", this._keyboardCloseHandler);
            this._keyboardCloseHandler = null;
        }
    }
}
theme.initMeganavs = function () {
    theme.headerMeganavs = new Meganav({
        $meganavs: dqa(".site-nav__dropdown"),
        $meganavToggle: dqa(".site-nav__meganav-toggle"),
        preventDuplicates: true,
        closeOnPageClick: true,
    });
    theme.drawerMeganavs = new Meganav({
        $meganavs: dqa(".meganav--drawer"),
        $meganavToggle: dqa(".drawer__meganav-toggle"),
    });
    var _a = [dq(".meganav--index"), dq(".index__meganav-toggle")],
        indexNav = _a[0],
        indexToggle = _a[1];
    if (indexNav && indexToggle) {
        theme.indexMeganavs = new Meganav({
            $meganavs: dqa(".meganav--index"),
            $meganavToggle: dqa(".index__meganav-toggle"),
        });
    }
};
theme.sortCollection = function () {
    Shopify.queryParams.sort_by = theme.cache.$sortDropdown.value;
    location.search = new URLSearchParams(Shopify.queryParams).toString();
};
theme.sortCollectionMobile = function () {
    Shopify.queryParams.sort_by = theme.cache.$sortDropdownMobile.value;
    location.search = new URLSearchParams(Shopify.queryParams).toString();
};
theme.filterCollection = function () {
    if (!theme.cache.$tagsDropdown) {
        return;
    }
    delete Shopify.queryParams.page;
    if (Object.keys(Shopify.queryParams).length === 0) {
        location.href = theme.cache.$tagsDropdown.value;
    } else {
        location.href = theme.cache.$tagsDropdown.value + "?" + new URLSearchParams(Shopify.queryParams).toString();
    }
};
theme.setQueryParams = function () {
    // Set current sort by value
    if (theme.cache.$sortDropdown) {
        if (Shopify.queryParams.sort_by) {
            theme.cache.$sortDropdown.value = Shopify.queryParams.sort_by;
            theme.cache.$sortDropdownMobile.value = Shopify.queryParams.sort_by;
        } else {
            theme.cache.$sortDropdown.value = theme.cache.$sortDropdown.dataset.defaultSort;
            theme.cache.$sortDropdownMobile.value = theme.cache.$sortDropdownMobile.dataset.defaultSort;
        }
    }
};
// function for flying cart:
function renderBar() {
    var incentivizeSection = document.querySelector("#progressSpan");
    var oldWidth = getById("oldWidth");
    fetch("?sections=cartupselldiv")
        .then(function (response) {
            return response.json();
        })
        .then(function (text) {
            var html = document.createElement("div");
            html.innerHTML = text.cartupselldiv;
            var incentivizer = html.querySelector("#progressSpan");
            var newWidth = html.querySelector("#newWidth");
            if (incentivizer) {
                incentivizeSection.textContent = incentivizer.textContent;
                oldWidth.style.width = newWidth.textContent;
            }
        });
}
theme.headerSearch = {
    searchShowClass: "site-header__search-input--visible",
    inputClass: "site-header__search-input",
    submitClass: "site-header__search-submit",
};
class Drawers {
    constructor(id, position) {
        var _this = this;
        this.handlePageClick = function () {
            _this.closeDrawer();
        };
        this.handleParentKeyUp = function (event) {
            if (event.key === "Escape" || event.keyCode === 27) {
                _this.closeDrawer();
            }
        };
        this.nodes = {
            parent: dq("body, html"),
            page: dq("#PageContainer"),
            moved: dq(".is-moved-by-drawer"),
        };
        this.config = {
            close: ".js-drawer-close",
            open: ".js-drawer-open-".concat(position),
            openClass: "js-drawer-open",
            dirOpenClass: "js-drawer-open-".concat(position),
        };
        this.position = position;
        this.drawer = getById(id);
        this.open = dqa(this.config.open);
        this.drawerIsOpen = false;
        if (!this.drawer) {
            return;
        }
        this.init();
    }
    init() {
        var _this = this;
        this.open.forEach(function (item) {
            item.setAttribute("aria-expanded", "false");
            item.addEventListener("click", function (e) {
                return _this.openDrawer(e);
            });
        });
        this.drawer.querySelectorAll(this.config.close).forEach(function (item) {
            item.addEventListener("click", _this.closeDrawer);
        });
    }
    openDrawer(evt) {
        var _this = this;
        var externalCall = false;
        if (this.drawerIsOpen) {
            return;
        }
        this.open.forEach(function (item) {
            item.classList.add(_this.config.openClass);
        });
        if (evt) {
            evt.preventDefault();
        } else {
            externalCall = true;
        }
        if (evt && evt.stopPropagation) {
            evt.stopPropagation();
            this.activeSource = evt.currentTarget;
        }
        if (this.drawerIsOpen && !externalCall) {
            return this.closeDrawer();
        }
        this.nodes.moved.classList.add("is-transitioning");
        this.nodes.parent.classList.add(this.config.openClass, this.config.dirOpenClass);
        this.drawerIsOpen = true;
        // Set focus on drawer
        ShopifyCanvas.A11yHelpers.trapFocus(this.drawer, "drawer_focus");
        if (this.activeSource && this.activeSource.getAttribute("aria-expanded")) {
            this.activeSource.setAttribute("aria-expanded", "true");
        }
        this.bindEvents();
    }
    closeDrawer() {
        var _this = this;
        if (!this.drawerIsOpen) {
            return;
        }
        this.open.forEach(function (item) {
            item.classList.remove(_this.config.openClass);
        });
        var activeElement = document.activeElement || null;
        activeElement === null || activeElement === void 0 ? void 0 : activeElement.blur();
        this.nodes.parent.classList.remove(this.config.dirOpenClass, this.config.openClass);
        this.drawerIsOpen = false;
        // Remove focus on drawer
        ShopifyCanvas.A11yHelpers.removeTrapFocus(this.drawer, "drawer_focus");
        if (this.activeSource && this.activeSource.getAttribute("aria-expanded")) {
            this.activeSource.setAttribute("aria-expanded", "false");
        }
        this.unbindEvents();
    }
    bindEvents() {
        var _this = this;
        this.nodes.page.addEventListener(
            "touchmove",
            function () {
                return false;
            },
            { passive: true },
        );
        this.nodes.page.addEventListener("click", function () {
            return _this.handlePageClick();
        });
        this.nodes.parent.addEventListener("keyup", function (evt) {
            return _this.handleParentKeyUp(evt);
        });
    }
    unbindEvents() {
        this.nodes.page.removeEventListener("click", this.handlePageClick);
        this.nodes.parent.removeEventListener("keyup", this.handleParentKeyUp);
    }
}
function start() {
    var _a, _b, _c;
    //product functions
    if (theme.productSingleObject) {
        // Pre-loading product images, to avoid a lag when a thumbnail is clicked, or
        //     // when a variant is selected that has a variant image.
        Shopify.Image.preload(theme.productSingleObject.images, "large");
        theme.initProductVariant();
        theme.productImageSwitch();
        theme.productZoomImage();
        theme.setActiveThumbnail(theme.cache.$productFeaturedImage);
    }
    new Drawers("NavDrawer", "left");
    theme.initHeaderSearch();
    theme.initMeganavs();
    theme.drawerSearch();
    theme.siteNavSizing();
    theme.setQueryParams();
    theme.cache.$numberInput.forEach(function (input) {
        return new QtySelector(input);
    });
    // Bind events
    theme.productThumbnailSlider();
    (_a = theme.cache.$sortDropdown) === null || _a === void 0 ? void 0 : _a.addEventListener("change", theme.sortCollection);
    (_b = theme.cache.$tagsDropdown) === null || _b === void 0 ? void 0 : _b.addEventListener("change", theme.filterCollection);
    (_c = theme.cache.$sortDropdownMobile) === null || _c === void 0 ? void 0 : _c.addEventListener("change", theme.sortCollectionMobile);
    // theme.cache.$window.on('scroll', $.throttle(15, theme.stickyHeaderOnScroll));
    dq(".go-cart__trigger").addEventListener("click", renderBar);
    dq(".go-cart__trigger").addEventListener("click", (e) => {
        /** @type {HTMLButtonElement}*/
        const btn = e.currentTarget;
        const isExpanded = btn.getAttribute("aria-expanded") === "true";
        btn.setAttribute("aria-expanded", !isExpanded);
        btn.setAttribute("aria-label", isExpanded ? "Close menu" : "Open menu");
    });
}
window.addEventListener("load", function () {
    return start();
});
